import { Translations } from '@/utils/translations/Translations';

export const MODAL_TAB_IDS = ['partner', 'contacts', 'awards'] as const;

export type ModalTab = (typeof MODAL_TAB_IDS)[number];
export const DEFAULT_MODAL_TAB: ModalTab = MODAL_TAB_IDS[0];

export function getModalTabConfig(translatedText: Translations) {
  return [
    {
      id: 'partner' as const,
      label: translatedText.partnerUpdateModal.tabPartnerInfo,
      saveLabel: translatedText.partnerUpdateModal.savePartnerInfo,
    },
    {
      id: 'contacts' as const,
      label: translatedText.partnerUpdateModal.tabContacts,
      saveLabel: translatedText.partnerUpdateModal.saveContacts,
    },
    {
      id: 'awards' as const,
      label: translatedText.partnerUpdateModal.tabYearsAwarded,
      saveLabel: translatedText.partnerUpdateModal.saveAwards,
    },
  ];
}

export function createModalTabBooleanState(value = false): Record<ModalTab, boolean> {
  return MODAL_TAB_IDS.reduce(
    (acc, tab) => {
      acc[tab] = value;
      return acc;
    },
    {} as Record<ModalTab, boolean>
  );
}
